import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaPlus, FaClock } from 'react-icons/fa';
import { Page, PageHeader, Card, SearchInput, Alert, Loading, formatMoney } from '../../ui';
import { api } from '../../ui/api';

const startingPrice = (service) => {
  const costs = (service.service_requirements || [])
    .flatMap((r) => r.details || [])
    .map((d) => Number(d.cost))
    .filter((n) => !Number.isNaN(n));
  return costs.length ? Math.min(...costs) : null;
};

const ManageServices = () => {
  const [services, setServices] = useState(null);
  const [error, setError] = useState('');
  const [query, setQuery] = useState('');
  const [category, setCategory] = useState('All');

  useEffect(() => {
    api('/service/services')
      .then(setServices)
      .catch((e) => { setError(e.message); setServices([]); });
  }, []);

  const categories = ['All', ...new Set((services || []).map((s) => s.category && s.category.name).filter(Boolean))];
  const q = query.toLowerCase();
  const shown = (services || []).filter((s) =>
    (category === 'All' || (s.category && s.category.name) === category)
    && (s.service_name.toLowerCase().includes(q) || (s.service_id || '').toLowerCase().includes(q)));

  return (
    <Page>
      <PageHeader
        title="Services"
        subtitle="Everything customers can book, with its options and pricing."
        actions={<Link to="/manage-services/add-service" className="btn btn-primary"><FaPlus /> Add service</Link>}
      />
      <Alert>{error}</Alert>

      <Card flush>
        <div className="toolbar">
          <SearchInput value={query} onChange={setQuery} placeholder="Search services" />
          <div className="chips">
            {categories.map((c) => (
              <button key={c} className={`chip${c === category ? ' on' : ''}`} onClick={() => setCategory(c)}>{c}</button>
            ))}
          </div>
        </div>
      </Card>

      {!services ? <Loading /> : shown.length === 0 ? (
        <Card><p className="muted" style={{ textAlign: 'center', padding: '24px 0' }}>No services match.</p></Card>
      ) : (
        <div className="service-grid">
          {shown.map((service) => {
            const price = startingPrice(service);
            const firstOption = (service.service_requirements?.[0]?.details || [])[0] || {};
            return (
              <article key={service.id} className="service-card">
                <div className="media">
                  {service.images && service.images[0] && <img src={service.images[0]} alt={service.service_name} loading="lazy" />}
                </div>
                <div className="body">
                  <span className="eyebrow">{service.category ? service.category.name : 'Uncategorised'}</span>
                  <h3>{service.service_name}</h3>
                  {service.description && <p className="desc">{service.description}</p>}
                </div>
                <div className="foot">
                  <div>
                    <div className="small muted">From</div>
                    <div className="strong">{price === null ? '—' : formatMoney(price)}</div>
                  </div>
                  {firstOption.duration && <span className="small muted"><FaClock size={11} /> {firstOption.duration}</span>}
                  <Link to={`/manage-services/view-service/${service.id}`} className="btn btn-secondary btn-sm">View / edit</Link>
                </div>
              </article>
            );
          })}
        </div>
      )}
    </Page>
  );
};

export default ManageServices;
